import { useController, useFormContext, type FieldValues, type Path } from "react-hook-form";
import FontsSelect from "../FontsSelect";
import { useVariantFieldDisabled } from "./context/VariantFieldContext";

export interface FormFontsSelectProps<TFieldValues extends FieldValues = FieldValues> {
    name: Path<TFieldValues> | (string & NonNullable<unknown>);
    label: string;
    options: string[];
    placeholder?: string;
    disabled?: boolean;
}

export function FormFontsSelect<TFieldValues extends FieldValues = FieldValues>({
    name,
    label,
    options,
    placeholder,
    disabled,
}: FormFontsSelectProps<TFieldValues>) {
    const { control } = useFormContext<TFieldValues>();
    const {
        field,
        fieldState: { error },
    } = useController<TFieldValues>({ control, name: name as any });

    const isAbDisabled = useVariantFieldDisabled(name as string);

    return (
        <FontsSelect
            label={label}
            options={options}
            placeholder={placeholder}
            onChange={(val) => field.onChange(val)}
            value={String(field.value ?? "")}
            error={error?.message}
            disabled={disabled || isAbDisabled}
        />
    );
}
